import { Layout, theme, Typography } from "antd";
import AdminsComponent from "../components/admins/AdminsComponent";
import AdminsTable from "../components/admins/AdminsTable";

const { Content } = Layout;

const Admins = () => {
  const {
    token: { colorBgContainer },
  } = theme.useToken();
  return (
    <Layout
      style={{
        marginLeft: 200,
      }}
    >
      <Content
        style={{
          margin: "24px 16px 0",
          overflow: "initial",
        }}
      >
        <div
          className="page-container"
          style={{
            background: colorBgContainer,
          }}
        >
          <Typography.Title level={5} className="titles-start">
            ADMİNLƏR
          </Typography.Title>
          <AdminsComponent />
          <Typography.Title level={5} className="titles-start">
            ƏMƏKDAŞLAR
          </Typography.Title>
          <AdminsTable />
        </div>
      </Content>
    </Layout>
  );
};

export default Admins;
